import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function usePatientsComboBox() {
  const navigate = useNavigate();

  const [patients, setPatients] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPatients = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/patients/combobox', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((patient) => ({
          id: patient.id,
          label: patient.nome,
          phone: patient.whatsapp,
        }));
        setPatients(options);
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchPatients();
  }, [fetchPatients]);

  return { patients, isLoading, error, refetch: fetchPatients };
}
